import { get, isEmpty, isNil } from 'lodash';
import { MISSION_POSTPONE_STATUS } from 'containers/data-structure';
import { COLORS } from 'constants/design';
import moment from 'moment';
import {
  EXPERTISE_ACCOUNTING_ID,
  EXPERTISE_MEDICAL_ID,
} from 'containers/CourtManagerLegalProceedings/constants';
export const renderChipLabel = (status: string) => {
  switch (status) {
    case MISSION_POSTPONE_STATUS.PENDING:
      return 'En cours';
    case MISSION_POSTPONE_STATUS.VALIDATED:
      return 'Validée';
    case MISSION_POSTPONE_STATUS.REJECTED:
      return 'Rejetée';
    case MISSION_POSTPONE_STATUS.ENATTENTE:
      return 'En attente';
    case MISSION_POSTPONE_STATUS.REALISEE:
      return 'Realisée';
    case MISSION_POSTPONE_STATUS.PENDING_APPRECIATION:
      return "En attente d'appréciation";
    case MISSION_POSTPONE_STATUS.PV_DE_CARENCE:
      return 'Pv de carence';
    case MISSION_POSTPONE_STATUS.REPORT_EXPERTISE:
      return "Report d'expertise";
    case MISSION_POSTPONE_STATUS.REJETEE_PAR_EXPERT:
      return "Rejetée par l'expert";
    case MISSION_POSTPONE_STATUS.ENATTENTE_APPRECIATION:
      return "En attente d'appréciation";
    default:
      return 'En cours';
  }
};
export const renderColor = (status: string) => {
  switch (status) {
    case MISSION_POSTPONE_STATUS.PENDING:
      return COLORS.PRIMARY_BUTTON_BLUE;
    case MISSION_POSTPONE_STATUS.VALIDATED:
      return COLORS.GREEN;
    case MISSION_POSTPONE_STATUS.REJECTED:
      return COLORS.RED;
    case MISSION_POSTPONE_STATUS.ENATTENTE:
      return COLORS.GREY;
    case MISSION_POSTPONE_STATUS.REALISEE:
      return COLORS.GREEN;
    case MISSION_POSTPONE_STATUS.PV_DE_CARENCE:
      return COLORS.RED;
    case MISSION_POSTPONE_STATUS.REPORT_EXPERTISE:
      return COLORS.YELLOW;
    case MISSION_POSTPONE_STATUS.REJETEE_PAR_EXPERT:
      return COLORS.RED;
    case MISSION_POSTPONE_STATUS.ENATTENTE_APPRECIATION:
      return COLORS.GREY;
    default:
      return COLORS.PRIMARY_BUTTON_BLUE;
  }
};
export const renderTitleAccordion = (recap: any, title: any) => {
  if (Number(get(recap, 'mission.type', '')) === EXPERTISE_MEDICAL_ID) {
    return (
      title +
      ' DE LA VICTIME : ' +
      get(recap, 'mission.victims[0].firstName') +
      ' ' +
      get(recap, 'mission.victims[0].lastName') +
      ' - ' +
      moment(recap.createdAt).format('DD/MM/YYYY')
    );
  } else if (
    Number(get(recap, 'mission.type', '')) === EXPERTISE_ACCOUNTING_ID &&
    !isEmpty(get(recap, 'mission.victims', []))
  ) {
    return (
      title +
      ' DE LA VICTIME : ' +
      get(recap, 'mission.victims[0].firstName') +
      ' ' +
      get(recap, 'mission.victims[0].lastName') +
      ' - ' +
      moment(recap.createdAt).format('DD/MM/YYYY')
    );
  } else {
    return (
      title +
      ' DE LA VEHICULE : ' +
      get(recap, 'mission.vehicles[0].registrationNumber') +
      ' ' +
      ' - ' +
      moment(recap.createdAt).format('DD/MM/YYYY')
    );
  }
};
export const isMissionPostPoneContainsNullDate = (missionPostPone: any) => {
  return !isEmpty(
    missionPostPone.filter((el: any) =>
      isNil(get(el, 'missionPostPone.postponeDate', null)),
    ),
  );
};
